// extracted by mini-css-extract-plugin
export default {"FileUpload":"hOGBMqJy","FileUploadPlaceholder":"n8hOI7Kz","sr-only":"KoTPBEVU"};